import Swipeable from '../behaviours/swipeable';
import React from 'react';
import Modal from '../modal/modal.jsx';
import APIManager from '../../services/api-manager';
import Picture from "../media/picture";

export default class TimeLine extends React.Component {

    constructor (props){
        super(props);
        this.state = {
            mouseDown: false,
            scrollX: 0,
            prevScrollX: 0,
            index: 1,
            showModal: false,
            modalContent: this.defaultModalContent()
        };

        this.APIManager = new APIManager();

        this.setIndex = this.setIndex.bind(this);
        this.increaseIndex = this.increaseIndex.bind(this);
        this.decreaseIndex = this.decreaseIndex.bind(this);
        this.calculatePaginationScroll = this.calculatePaginationScroll.bind(this);
        this.onPaginationMouseDown = this.onPaginationMouseDown.bind(this);
        this.onPaginationMouseMove = this.onPaginationMouseMove.bind(this);
        this.onPaginationMouseUp = this.onPaginationMouseUp.bind(this);
        this.onCloseDestinationModal = this.onCloseDestinationModal.bind(this);
        this.openDescription = this.openDescription.bind(this);
    }

    componentDidMount() {

    }

    componentWillUnmount( ) {
        clearInterval(this.interval);
    }


    setIndex(startIndex){
        clearInterval(this.animationInterval);
        let newIndex = this.state.index;

        this.animationInterval = setInterval(() => {
            if(startIndex > this.state.index) newIndex = this.state.index + 1;
            if(startIndex < this.state.index) newIndex = this.state.index - 1;

            this.setState({
                index: newIndex,
                scrollX: this.calculatePaginationScroll(newIndex),
                prevScrollX: this.state.scrollX
            });

            if(this.state.index === startIndex) clearInterval(this.animationInterval);
        }, 100);
    }

    decreaseIndex(){
        clearInterval(this.animationInterval);
        let currentIndex = this.state.index;
        let newIndex = currentIndex - 1;

        if(currentIndex - 1 >= 1) {
            this.setState({
                index: newIndex,
                scrollX: this.calculatePaginationScroll(newIndex)
            });
        }
    }

    increaseIndex(){
        clearInterval(this.animationInterval);
        let currentIndex = this.state.index;
        let newIndex = currentIndex + 1;

        if ( this.props.items.length >= currentIndex + 1 ) {
            this.setState({
                index: newIndex,
                scrollX: this.calculatePaginationScroll(newIndex)
            });
        }
    }

    calculatePaginationScroll(newIndex){
        let itemWidth = 150;
        let containerWidth = itemWidth * 7;
        let scrollerWidth = itemWidth * (this.props.items.length - 1);

        let newScrollX = itemWidth * (newIndex - 3);
        let scrollXmt = 0;
        let scrollXlt = scrollerWidth - containerWidth;

        if( newScrollX >= scrollXmt && newScrollX <= scrollXlt) return newScrollX;
        return this.state.scrollX;
    }

    onPaginationMouseDown(e){
        this.setState({mouseDown: true, pageX: e.pageX, prevScrollX: this.state.scrollX})
    }

    onPaginationMouseMove(e){
        if(this.state.mouseDown){
            let newScrollX = this.state.prevScrollX + (this.state.pageX - e.pageX);
            this.setState({scrollX: newScrollX > 0 ? newScrollX : 0 });
        }
    }

    onPaginationMouseUp(e){
        this.setState({mouseDown: false});
    }

    onCloseDestinationModal(){
       //if(this.abortController) this.abortController.abort();


       this.setState({
           showModal:false,
           modalContent: this.defaultModalContent()
       });
    }

    loadDestination(url){
        let success = (html) => {
            let newContent = (<div className="text-left" dangerouslySetInnerHTML={{__html: html}} />);
            this.setState({modalContent: newContent});
        };

        let failure = (response) => {
            this.setState({showModal: false, modalContent: response});
        };

        this.setState({ showModal: true}, () => {
            //set new abort controller for request
            //this.abortController = new AbortController();
           // this.signal = this.abortController.signal;
            //this.api.setAbortSignal(this.signal).getPartial(url, success, failure, true, this.signal)
            this.APIManager.getPartial(url, success, failure, true, this.signal)
        })
    }

    openDescription(key, title, description){
        let content = ([
            <h3 key={key+'model_desc_title'}>{title}</h3>,
            <span key={key+'model_desc_desc'} dangerouslySetInnerHTML={{__html:description}} />
        ]);

        this.setState({showModal: true, modalContent: content});
    }

    renderTimelineItemLink = (item) => {
        if(typeof item.hotel !== 'undefined' ) {
            return (<div className="button secondary text-black" onClick={ () => { this.loadDestination(item.hotel) } } >Hotel Guide</div> );
        } else if(item.type === 'port' && item.url ){
            return (<div className="button secondary text-black" onClick={ () => { this.loadDestination(item.url) } } >Destination Guide</div> );
        }
    };

    renderTimelineItem(key, item){

        let image = item.image;
                return (
            <div className="itinerary-driver" key={key}>
                <div className="itinerary-driver--image">
                    <Picture src={image.path} filter={'cruise_driver_timeline'} alt={image.alt}/>
                    <div className="itinerary-driver--day">Day {item.day}</div>
                </div>
                <div className="itinerary-driver--content-container">
                    <h3 className="itinerary-driver--title">{item.title}</h3>
                    <h5 className="itinerary-driver--date">{item.date}</h5>

                    <p className="itinerary-driver--description">
                       <span dangerouslySetInnerHTML={{__html:(item.description||'').length < 160 ? item.description : item.description.slice(0, 160) + '...'}} />
                        { (item.description||'').length > 160 && <a onClick={ () => { this.openDescription(key, item.title, item.description) }}>Read More</a> }
                    </p>

                    { this.renderTimelineItemLink(item)}
                </div>
            </div>
        )
    }

    renderPagination(){
        let items= [];
        let count = this.props.items.length;
        let index = this.state.index;

        for (let i = 1; i <= count; i++) {
            let cssClass = '';
            let loopIndex = i;
            if(index - 1 === i) cssClass = 'before-active';
            if(index === i) cssClass = 'active';

            items.push((
                <li className={'timeline--pagination-item ' + cssClass} key={i} >
                    <span className="timeline--pagination-item-inner" onClick={() => this.setIndex(loopIndex)}>
                        <span className="timeline--pagination-diamond"></span>
                        <span className="timeline--pagination-day">Day {this.props.items[i-1].day}</span>
                    </span>
                </li>
            ));
        }
        return items;
    }

    renderTimelineItems(){
        let items= [];
        let count = this.props.items.length;
        let index = this.state.index;

        for (let i = 1; i <= count; i++) {
            let cssClass = '';
            if(index - 1 === i) cssClass = 'before-active';
            if(index === i) cssClass = 'active';

            items.push((
                <div key={'timeline-item_' + i} className={'timeline--item ' + cssClass} onClick={() => this.setIndex(i)}>
                    { this.renderTimelineItem(i, this.props.items[i-1]) }
                </div>
            ));
        }
        return items;
    }

    defaultModalContent(){
        return (
            <div className="loading">
                <p className="loading-title">LOADING</p>
                <div className="spinner">
                    <div className="rect1"></div>
                    <div className="rect2"></div>
                    <div className="rect3"></div>
                    <div className="rect4"></div>
                    <div className="rect5"></div>
                </div>
                <div className="loading-message">Retrieving destination guide content</div>
            </div>
        )
    }

    render () {
        const handlers = {
            onSwipedLeft: this.increaseIndex,
            onSwipedRight: this.decreaseIndex,
            preventDefaultTouchmoveEvent: true,
            trackTouch: true
        };

        return(
            <div className="timeline">
                <Modal show={this.state.showModal} onClose={ this.onCloseDestinationModal}> { this.state.modalContent } </Modal>
                <Swipeable className="timeline--items-container" {...handlers}>
                    {this.renderTimelineItems()}
                </Swipeable>
                <div className="timeline--controls">
                    <div className={"timeline--control-prev "  + (this.state.index <= 1 ? 'inactive':'') } onClick={this.decreaseIndex} />
                    {/*<div className="timeline--control-page"><div className="timeline--control-page-diamond"></div>Day { this.props.items[this.state.index - 1].day } </div>*/}
                    <div className={"timeline--control-next " + (this.state.index >= this.props.items.length ? 'inactive' : '') } onClick={this.increaseIndex} />
                </div>
                {/* <div className="timeline--pagination-overflow-container" onMouseDown={this.onPaginationMouseDown} onMouseMove={this.onPaginationMouseMove} onMouseUp={this.onPaginationMouseUp} onMouseLeave={this.onPaginationMouseUp}><ul className="timeline--pagination" style={{left: (this.state.scrollX * -1)}}>{ this.renderPagination() }</ul></div> */}
            </div>
        )
    }
}
